import(/* webpackMode: "eager" */ "/app/src/app/earn-now/page.tsx");
